import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Title, TextBody } from 'web-ui-components/lib/atoms/text';
import SvgIcon from '../../common/SvgIcon';
import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';

export const ModalBody = ({ content }) => {
  return (
    <div className="web-ui-components c-centered-group">
      <SvgIcon
        className="center-block account-success u-component-spacing"
        id="icon-success"
        width="64px"
        height="64px"
      />
      <Title size="h4">{content.preferencesUpdatedTitle}</Title>
      <TextBody className="u-text-align-center">
        {content.preferencesUpdatedBody}
      </TextBody>
    </div>
  );
};

export const ModalFooter = ({ onOkClick }) => (
  <div className="web-ui-components c-centered-group">
    <Button tabIndex="0" display="primary" onClick={onOkClick}>
      Ok
    </Button>
  </div>
);

export const SuccessModal = ({ onOkClick, show, content }) => (
  <PatternLibModalComponent
    show={show}
    onHide={onOkClick}
    bsSize={'medium'}
    modalBody={<ModalBody content={content} />}
    modalFooter={<ModalFooter onOkClick={onOkClick} />}
    customClass={'c-modal'}
    closeButton={false}
    backdrop="static"
  />
);

SuccessModal.propTypes = {
  onOkClick: PropTypes.func,
  show: PropTypes.bool,
  content: PropTypes.object,
};

ModalBody.propTypes = {
  content: PropTypes.shape({
    preferencesUpdatedBody: PropTypes.string,
    preferencesUpdatedTitle: PropTypes.string,
  }),
};

ModalFooter.propTypes = {
  onOkClick: PropTypes.func,
};

ModalFooter.propTypes = {
  onOkClick: PropTypes.func,
};
